import React from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { IRequestFilter } from "../../../../../../../models";
import { useAppSelector } from "../../../../../../../redux/hooks";
import { compileNameOfProperty } from "../../../../../../../utils";
import { TextInput } from "../../../../../../common/inputs/textInput";
import { RequestFilterPopUpStyle } from "../filterStyle.jss";
import { BooleaMultiSelector } from "../../../../../../common/selectors";
import { SelectorTipoCertificado } from "../../../../../common/selectors/certificate/singleCertificateSort";
import { OrdenNumeroDocumento } from "../../../../../common/controls/documentSort/documentSortControl";
import { useDocumentSortFilter } from "../../../../../../../hooks/request/useDocumentSortFilter";

interface IProps {
    onInputChange: (event: any, name: string) => void;
    schema: any;
    onEnterKey: () => void;
    onNullableBooleanChange: (name: string, booleanValue: boolean | undefined) => void;
}

export const RequestOthersPivotFilter: React.FC<IProps> = ({ onInputChange, onEnterKey, schema, onNullableBooleanChange }) => {
    const theme = useTheme();
    const styles = RequestFilterPopUpStyle({ theme });
    const { filter } = useAppSelector((state) => state.requestListFilter);
    const { t } = useTranslation("common", { keyPrefix: "REQUEST_FILTER.FILTER" });
    const { isAllowed: isDocumentSortAllowed, documentSort, onCertificateChange, onDirectionChange } = useDocumentSortFilter();

    return (
        <div className={`${styles.section}`}>
            {schema.certificateNumberWithTransportUnitNumber && (
                <TextInput
                    value={filter.certificateNumberWithTransportUnitNumber}
                    propertyName={compileNameOfProperty<IRequestFilter>("certificateNumberWithTransportUnitNumber")}
                    label={t("CERTIFICATE_NUMBER_TRANSPORT_UNIT_NUMBER")}
                    onChange={onInputChange}
                    onEnter={onEnterKey}
                    withCallOut={true}
                    calloutMessage={t("INFO.CERTIFICATE_NUMBER_TRANSPORT_UNIT_NUMBER")}
                />
            )}
            {schema.transportUnitNumberWithCertificateNumber && (
                <TextInput
                    value={filter.transportUnitNumberWithCertificateNumber}
                    propertyName={compileNameOfProperty<IRequestFilter>("transportUnitNumberWithCertificateNumber")}
                    label={t("TRANSPORT_UNIT_NUMBER_CERTIFICATE_NUMBER")}
                    onChange={onInputChange}
                    onEnter={onEnterKey}
                    withCallOut={true}
                    calloutMessage={t("INFO.TRANSPORT_UNIT_NUMBER_CERTIFICATE_NUMBER")}
                />
            )}
            {schema.vuaVisible && (
                <BooleaMultiSelector
                    selectedKey={filter.vua}
                    propertyName={compileNameOfProperty<IRequestFilter>("vua")}
                    title={t("VUA")}
                    onChange={onNullableBooleanChange}
                />
            )}
            {isDocumentSortAllowed && (
                <SelectorTipoCertificado
                    selectedKey={documentSort.certificateTypeId}
                    onChange={onCertificateChange}
                />
            )}
            {isDocumentSortAllowed && documentSort.certificateTypeId !== undefined && (
                <OrdenNumeroDocumento
                    enabled={documentSort.certificateTypeId !== undefined}
                    direction={documentSort.direction}
                    onDirectionChange={onDirectionChange}
                />
            )}
        </div>
    );
};
